import React from "react";
import useAuth from "../../hooks/useAuth";
import BotMIS from "./BotMIS";

const ManageBotMIS = () => {
    const { user } = useAuth();
    return <>{user && <BotMIS />}</>;
};

export default ManageBotMIS;
